import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MatchStatuses } from "@common/constants";
import { ResultsEventContext } from "@state/context/results";
import ResultsEventStatisticsButton from "./ResultsEventStatisticsButton";
import { ScoreRenderer } from "./ScoreRenderer";
import ResultsEventEmptySpaces from "./ResultsEventEmptySpaces";
import Odd from "./Odd";
import { tbodyColspanMax } from "./utils";

export default function ResultsEventData() {
	const event = useContext(ResultsEventContext);
	const translationHook = useTranslation();

	if (MatchStatuses.includes(event.matchStatus.abrv)) {
		return (
			<>
				<td className="table--results__body__data table--results__body__data--stats">
					&nbsp;
				</td>
				<td
					className="table--results__body__data table--results__body__data--postponed"
					colSpan={tbodyColspanMax - 3}
				>
					{translationHook.t<string>(
						"RESULTS.RESULT_CONTENT.POSTPONED"
					)}
				</td>
			</>
		);
	}

	return (
		<>
			<ResultsEventStatisticsButton />

			<ScoreRenderer />

			<td className="table--results__body__data table--results__body__data--tip">
				<strong>{event.tip}</strong>
			</td>

			<Odd />

			<ResultsEventEmptySpaces />
		</>
	);
}
